import { useBindDispatch } from 'hooks'
import { cleanup } from 'helpers/cleanup'

export const useLogout = () => {
    const { logoutDispatch } = useBindDispatch()

    const logout = async () => {
        await cleanup()
        logoutDispatch()
    }

    return { logout }
}
